import { render, staticRenderFns } from "./viewModal.vue?vue&type=template&id=0b352fb6&scoped=true&"
import script from "./viewModal.vue?vue&type=script&lang=js&"
export * from "./viewModal.vue?vue&type=script&lang=js&"
import style0 from "./viewModal.vue?vue&type=style&index=0&id=0b352fb6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b352fb6",
  null
  
)

export default component.exports